export enum KonkurrencestatusEnum {
    Offentlig = 1,
    IkkePubliceret = 2,
    Afviklet = 3,
    Slettet = 4
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/enums/KonkurrencestatusEnum.ts